import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon } from "react-bootstrap";

const renderRow = (document, onEdit, isReadOnly,onDelete) => (
    <tr key={document.Id}>
        <td>{document.Id}</td>
        <td>{document.Name}</td>
        
        <td>
            <Glyphicon 
                glyph='trash' 
                className={`glyphicon-trash${isReadOnly ? '.disabled' : ''}`} 
                onClick={isReadOnly ? undefined : () => onDelete(document)} 
                title='Удалить' />
        </td>
        <td>
            <Glyphicon 
                glyph='pencil' 
                className={`edit-glyph${isReadOnly ? '.disabled' : ''}`} 
                onClick={isReadOnly ? undefined : () => onEdit(document)} 
                title='Изменить' />
        </td>
    </tr>);

export const Table = ({ documents, fetching, onEdit, isReadOnly, onDelete }) => (
    <div>
        {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
        {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
        {fetching === fetchingState.FETCHED &&
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <td>№</td>
                        <td>Имя</td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {documents.map(d => renderRow(d, onEdit, isReadOnly, onDelete))}
                </tbody>
            </table>}
    </div>);


// WEBPACK FOOTER //
// ./src/components/settings/documents/Table.jsx